// Where an old "apply to this breakdown" link lands.
//
// /register/special/actor?bd=…&roleid=… is what the classic open-breakdown
// page and the login page (registerTrial) still send. With a breakdown on it
// the visitor wants to submit, so it enters the submission flow the way a role
// picked from the casting calls does: straight to step 1 when the link names a
// role, the breakdown's landing page (which lists its roles) when it doesn't.
// Step 1 and the landing page check the breakdown is still open themselves.
// Without a breakdown there is nothing to submit to, and the link stays with
// the classic signup (null).

import { buildFlowSearch, parseSubmissionParams } from "./submissionParams";

// Only the classic wizard reads these: `page=openbd` is the flag Routes.tsx
// used to add, `cwblabs` is stripped from every classic link too.
const CLASSIC_ONLY = ["page", "cwblabs"];

export const legacyBreakdownEntry = (
  search: string | undefined
): { pathname: string; search: string } | null => {
  const { bd, roleid } = parseSubmissionParams(search);
  if (!bd) return null;
  const params = new URLSearchParams(search || "");
  CLASSIC_ONLY.forEach((key) => params.delete(key));
  return {
    pathname: roleid ? "/submission/flow/step/1" : "/submission/boost",
    search: buildFlowSearch(params.toString(), bd, roleid),
  };
};

// The switch for this entry (Signup/docs/42 D2). The flow is on unless the build says
// REACT_APP_SUBMISSION_FLOW=off: a missing or empty setting keeps it on. Off sends breakdown
// links back to the classic wizard, as before the flow, without a code rollback. Only new
// applicants change path; the flow's own pages and email links keep working.
export const submissionFlowOn = (
  setting: string | undefined = process.env.REACT_APP_SUBMISSION_FLOW
): boolean => String(setting || "").trim().toLowerCase() !== "off";

// The classic wizard's query string, exactly as Routes.tsx built it before the flow:
// cwblabs dropped, and a breakdown link without a page gets page=openbd.
export const classicBreakdownSearch = (search: string | undefined): string => {
  const params = new URLSearchParams(search || "");
  params.delete("cwblabs");
  const classic = params.toString();
  return params.has("bd") && !params.has("page") ? `${classic}&page=openbd` : classic;
};
